import InputCreator, {
  TInputCreatorProps,
} from '~/components/atoms/FormControls/InputCreator';

import styles from './Textarea.module.scss';

export type TTextareaProps = TInputCreatorProps<
  JSX.IntrinsicElements['textarea']
>;
export default InputCreator<TTextareaProps, HTMLInputElement>(
  'textarea',
  styles.inputWrapper,
);
